/**
 * スマートハウス、戻るボタンが押された時のスタイルの初期化
 */
export function styleUndo() {
	//戻るボタンの時、javascriptの変化を初期化
	$(window).bind("unload", function () { });

	window.addEventListener('popstate', function (e) {
		$('#is-button-eco a').removeClass('is-link', 'is-link-move');
		$('#is-button-sun a').removeClass('is-link', 'is-link-move');
		$('#is-button-battery a').removeClass('is-link', 'is-link-move');
		$('#is-button-smart a').removeClass('is-link', 'is-link-move');
		$('#is-button-reform a').removeClass('is-link', 'is-link-move');
		$('#is-button-car a').removeClass('is-link', 'is-link-move');
	});
}